import { render, staticRenderFns } from "./InformacionProceso.vue?vue&type=template&id=dbaf522e&scoped=true"
import script from "./InformacionProceso.vue?vue&type=script&lang=js"
export * from "./InformacionProceso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaf522e",
  null
  
)

export default component.exports